<template>
  <el-dialog
    :key="WhatsThisFormFor"
    :title="thiDialogTitle"
    :visible.sync="dialogFormVisible"
    @open="OnTaskFormOpen"
    @close="OnTaskFormClose"
    append-to-body
    :destroy-on-close="true"
  >
    <el-form
      :model="taskForm"
      ref="taskForm"
      :rules="taskForRules"
      label-position="top"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item
            label="Responsable"
            :label-width="formLabelWidth"
            prop="responsible"
          >
            <EmployeeSelector
              :CurrentEmployee="taskForm.responsible"
              placeholder="Responsable"
              @selection-change="OnResponsibleSelected"
              :disabled="ViewTask"
              :filter-employees="filterEmployeesBySupervisor"
            />
          </el-form-item>
          <el-form-item
            v-if="WhatsThisFormFor === 1 || WhatsThisFormFor === 3"
            label="Creador"
            :label-width="formLabelWidth"
            prop="creator"
          >
            <EmployeeSelector
              :CurrentEmployee="taskForm.creator"
              placeholder="Creador"
              @selection-change="OnCreatorSelected"
              :disabled="ViewTask"
            />
          </el-form-item>
          <el-form-item
            label="Perspectiva"
            :label-width="formLabelWidth"
            prop="perspective"
          >
            <PerspectiveSelectorFilter
              :initialValue="taskForm.perspective"
              @PerspectiveSelectorFilterChange="
                onPerspectiveSelectorFilterChange
              "
              :loading="disablePerspective"
              :disabled="ViewTask"
            />
          </el-form-item>
          <el-form-item
            label="Tipo"
            :label-width="formLabelWidth"
            prop="typeStrategic"
          >
            <TypeStrategicFilter
              :initialValue="taskForm.typeStrategic"
              :isDisable="isTypeStrategicDisable || ViewTask"
              :currentEmployee="currentEmployee"
              @TypeStrategicFilterChange="onTypeStrategicFilterChange"
            />
          </el-form-item>
          <!-- <el-row>
            <el-col :span="8"> -->
          <el-form-item
            label="Porcentaje"
            :label-width="formLabelWidth"
            prop="percentage"
          >
            <PercentageSelector
              :initialValue="taskForm.percentage"
              @PercentageChanged="OnPercentageChanged"
              :disabled="ViewTask"
            />
          </el-form-item>
          <!-- </el-col>
            <el-col :span="15"> -->
          <el-form-item label="Fecha Inicio" prop="dateInit">
            <el-date-picker
              class="DatePicker"
              v-model="taskForm.dateInit"
              type="date"
              size="mini"
              placeholder="Fecha Inicio"
              @change="onFechaIniChange"
              :disabled="ViewTask"
            >
            </el-date-picker>
          </el-form-item>

          <!-- </el-col>
          </el-row> -->
        </el-col>
        <el-col :span="16">
          <el-form-item
            label="Descripción"
            :label-width="formLabelWidth"
            prop="shortDesc"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              placeholder="Please input"
              v-model="taskForm.shortDesc"
              :disabled="ViewTask"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            label="Detalles"
            :label-width="formLabelWidth"
            prop="longDesc"
          >
            <quill-editor
              ref="myQuillEditor"
              v-model="taskForm.longDesc"
              :disabled="ViewTask"
            />
          </el-form-item>

          <el-row v-if="WhatsThisFormFor === 0 || WhatsThisFormFor === 1">
            <el-col :span="12">
              <el-form-item
                label="Tiempo Estimado"
                class="formItemTopPad"
                prop="Time"
              >
                <!-- <el-input-number
                size="large"
                v-model="form.Time"
                :min="0"
                :controls="false"
              ></el-input-number> -->
                <TimeSelector
                  :timeToEdit="taskForm.Time"
                  @TimeSelected="onTimeSelected"
                  :disabled="ViewTask"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Minutos/Horas"
                class="formItemTopPad"
                prop="minuteHour"
              >
                <MinuteOurSelectoForTasks
                  :MinuteHour="taskForm.minuteHour"
                  :disabled="true"
                  @MinuteHoureChanged="MinuteHoureChanged"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-alert
              v-if="
                (taskForm.Time > 8 && taskForm.minuteHour === 'h') ||
                (taskForm.Time > 480 && taskForm.minuteHour === 'm')
              "
              type="error"
              title="Error de tiempo estimado"
              description="El tiempo No puede ser mayor a 8 horas o su equivalente 480 minutos"
              show-icon
            >
            </el-alert>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="Fecha Fin"
                class="formItemTopPad"
                prop="DateEnd"
              >
                <el-date-picker
                  v-model="taskForm.DateEnd"
                  type="date"
                  size="mini"
                  width="50%"
                  placeholder="Fecha Fin"
                  @change="onFechaFinChange"
                  :disabled="ViewTask"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                v-if="WhatsThisFormFor === 0 || WhatsThisFormFor === 1"
                label="Fijar en Reportede tareas"
                class="formItemTopPad"
                prop="fixed"
              >
                <el-checkbox
                  size="medium"
                  v-model="taskForm.fixed"
                  :checked="taskForm.chequed"
                  @change="onFixedChange"
                  :disabled="ViewTask"
                  >Fija?
                </el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-alert
          v-if="ShowDateAlert"
          :title="dateAlertTitle"
          type="error"
          :closable="false"
          show-icon
        >
        </el-alert>
        <el-alert
          v-if="
            (WhatsThisFormFor === 0 || WhatsThisFormFor === 1) &&
            ShowDateIniAlert
          "
          :title="dateIniAlertTitle"
          type="error"
          :closable="false"
          show-icon
        >
        </el-alert>
        <el-alert
          v-if="
            (WhatsThisFormFor === 0 || WhatsThisFormFor === 1) &&
            ShowDateFinAlert
          "
          :title="dateFinAlertTitle"
          type="error"
          :closable="false"
          show-icon
        >
        </el-alert>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="OnTaskFormClose">Cancelar</el-button>
      <el-button
        type="primary"
        :disabled="
          ViewTask ||
          DisableSaveButon ||
          (taskForm.Time > 8 && taskForm.minuteHour === 'h') ||
          (taskForm.Time > 480 && taskForm.minuteHour === 'm')
        "
        @click="OnSaveInfo"
        >Guardar</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import EmployeeSelector from "@/components/Company/EmployeeSelector";
import TypeStrategicFilter from "@/components/cmi/ObjectivesReport/TypeStrategicFilter";
import PerspectiveSelectorFilter from "@/components/cmi/ObjectivesReport/PerspectiveSelectorFilter";
import PercentageSelector from "@/components/cmi/ObjectivesReport/PercentageSelector";
import { formatDate } from "@/utils";
import MinuteOurSelectoForTasks from "@/components/cmi/ObjectivesReport/MinuteOurSelectoForTasks";
import TimeSelector from "@/components/cmi/ObjectivesReport/TimeSelector";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "TaskFormDialog",
  components: {
    EmployeeSelector,
    TypeStrategicFilter,
    PerspectiveSelectorFilter,
    PercentageSelector,
    MinuteOurSelectoForTasks,
    TimeSelector,
    quillEditor
  },
  props: {
    ViewTask: {
      type: Boolean,
      default: false
    },
    TaskFormVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    ObjectiveRow: {
      type: Object,
      dafault: () => {},
      required: false
    },
    TaskRow: {
      type: Object,
      dafault: () => {},
      required: false
    },
    //WhatsThisFormFor: 0 crear, 1 editar
    WhatsThisFormFor: {
      type: Number,
      default: 0,
      required: true
    },
    NegotiationId: {
      type: Number,
      default: 0,
      required: false
    },
    ProspectId: {
      type: Number,
      default: 0,
      required: false
    },
    CustomerCode: {
      type: Number,
      default: 0,
      required: false
    }
  },
  data() {
    return {
      taskForm: {
        responsible: "",
        creator: "",
        perspective: "",
        typeStrategic: "",
        percentage: "",
        dateInit: "",
        DateEnd: "",
        shortDesc: "",
        longDesc: "",
        fixed: false,
        chequed: false,
        Time: 0.5,
        minuteHour: "h"
      },
      taskForRules: {
        responsible: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        creator: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        perspective: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        typeStrategic: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        percentage: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        dateInit: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        DateEnd: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        shortDesc: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        longDesc: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ]
        // fixed: [
        //   { required: true, message: 'Este campo es requerido', trigger: 'blur' }
        // ],
        // Time: [
        //   {
        //     required: true,
        //     message: "Este campo es requerido",
        //     trigger: "blur"
        //   }
        // ]
        // minuteHour: [
        //   { required: true, message: 'Este campo es requerido', trigger: 'blur' }
        // ],
      },
      formLabelWidth: "120px",
      Title: "Object",
      currentEmployee: 0,
      isTypeStrategicDisable: false,
      ShowDateAlert: false,
      dateAlertTitle: "",
      dateIniAlertTitle: "",
      ShowDateIniAlert: false,
      dateFinAlertTitle: "",
      ShowDateFinAlert: false,
      DisableSaveButonCount: 0,
      DisableSaveButonCount2: 0,
      DisableSaveButonCount3: 0,
      disablePerspective: false
    };
  },
  mounted() {
    if (this.currentUser.PositionID !== 16) {
      this.taskForm.typeStrategic = 1;
      this.isTypeStrategicDisable = true;
    }
  },
  updated() {
    if (this.currentUser.PositionID !== 16) {
      this.taskForm.typeStrategic = 1;
      this.isTypeStrategicDisable = true;
    }
  },
  computed: {
    dialogFormVisible() {
      return this.TaskFormVisible;
    },
    thiDialogTitle() {
      if (this.WhatsThisFormFor === 0) {
        return (
          this.ObjectiveRow.ObjectiveCombinedId +
          " - " +
          this.ObjectiveRow.ObjectiveShortDescription
        );
      } else if (this.WhatsThisFormFor === 1) {
        return (
          this.TaskRow.CombinedTaskId + " - " + this.TaskRow.ShortDescription
        );
      } else if (this.WhatsThisFormFor === 2) {
        return "Nuevo Objetivo";
      } else if (this.WhatsThisFormFor === 3) {
        return (
          this.ObjectiveRow.ObjectiveCombinedId +
          " - " +
          this.ObjectiveRow.ObjectiveShortDescription
        );
      } else {
        return "";
      }
    },
    DisableSaveButon() {
      if (
        this.DisableSaveButonCount +
          this.DisableSaveButonCount2 +
          this.DisableSaveButonCount3 >
        0
      ) {
        return true;
      } else {
        return false;
      }
    }
    // IsMinuteHour() {
    //   let minuteHours;
    //   if (this.taskForm.minuteHour === "m") {
    //     minuteHours = 480;
    //   } else {
    //     minuteHours = 8;
    //   }
    //   return minuteHours;
    // }
  },
  methods: {
    filterEmployeesBySupervisor(list) {
      if (!this.currentUser || !this.currentUser.EmployeeId) {
        return list;
      }

      const isCeo = this.IsInRoles && this.IsInRoles([this.roles.CEO]);
      if (isCeo) {
        return list;
      }

      const currentEmployeeId = Number(this.currentUser.EmployeeId);

      return list.filter((item) => {
        const employeeId = Number(item.EmployeeID ?? item.EmployeeId);
        const supervisorId = Number(item.SupervisorId);

        return (
          employeeId === currentEmployeeId || supervisorId === currentEmployeeId
        );
      });
    },
    OnTaskFormOpen() {
      if (this.currentUser.PositionID !== 16) {
        this.taskForm.typeStrategic = 1;
        this.isTypeStrategicDisable = true;
        if (this.WhatsThisFormFor === 0 || this.WhatsThisFormFor === 1) {
          this.taskForm.perspective = this.ObjectiveRow.PerpectiveID;
          this.disablePerspective = true;
        }
      }

      // switch (this.WhatsThisFormFor) {
      //   case 0: {
      //     break;
      //   }
      //   case 1: {
      //     this.taskForm.responsible = this.TaskRow.ResponsableId;
      //     this.taskForm.perspective = this.TaskRow.PerpectiveID;
      //     this.taskForm.typeStrategic = this.TaskRow.TypeStrategic;
      //     this.taskForm.percentage = this.TaskRow.PercentageProsposal;
      //     this.taskForm.dateInit = this.TaskRow.InitialDate;
      //     this.taskForm.DateEnd = this.TaskRow.LimiteDate;
      //     this.taskForm.shortDesc = this.TaskRow.ShortDescription;
      //     this.taskForm.longDesc = this.TaskRow.LongDescription;
      //     this.taskForm.chequed = this.TaskRow.IsFixed;
      //     //this.taskForm.fixed = this.TaskRow.IsFixed;
      //     break;
      //   }
      //   case 2: {
      //     break;
      //   }
      //   case 3: {
      //     this.taskForm.responsible = this.ObjectiveRow.ResponsableId;
      //     this.taskForm.perspective = this.ObjectiveRow.PerpectiveID;
      //     this.taskForm.typeStrategic = this.ObjectiveRow.TypeStrategic;
      //     this.taskForm.percentage = this.ObjectiveRow.ExecutionPercentage;
      //     this.taskForm.dateInit = this.ObjectiveRow.DateInit;
      //     this.taskForm.DateEnd = this.ObjectiveRow.DateEnd;
      //     this.taskForm.shortDesc = this.ObjectiveRow.ObjectiveShortDescription;
      //     this.taskForm.longDesc = this.ObjectiveRow.ObjectiveLongDescription;
      //     break;
      //   }
      // }
    },
    OnTaskFormClose() {
      this.FormCleaning();
      this.$emit("ClosingTaskFormDialog");
    },
    OnResponsibleSelected(responsible) {
      this.taskForm.responsible = responsible;
    },
    OnCreatorSelected(creator) {
      this.taskForm.creator = creator;
    },
    onPerspectiveSelectorFilterChange(perspective) {
      this.taskForm.perspective = perspective;
    },
    onTypeStrategicFilterChange(typeStrategic) {
      this.taskForm.typeStrategic = typeStrategic;
    },
    OnPercentageChanged(percentage) {
      this.taskForm.percentage = percentage;
    },
    async OnSaveInfo() {
      this.$refs.taskForm.validate(async (valid) => {
        if (valid) {
          if (this.WhatsThisFormFor === 0 || this.WhatsThisFormFor === 1) {
            await this.TaskCall();
          } else if (
            this.WhatsThisFormFor === 2 ||
            this.WhatsThisFormFor === 3
          ) {
            await this.ObjectiveCall();
          }
        }
      });
      // this.WhatsThisFormFor 0 creacion tarea, 1edicion tare, 2 creacion objetivos, 3 edicion objetivos
    },
    async TaskCall() {
      let parameters = {
        CompanySelected: "TB",
        Description: this.taskForm.shortDesc,
        Name: this.taskForm.shortDesc,
        ResponsableId: this.taskForm.responsible,
        PerpectiveId: this.taskForm.perspective,
        Typetask: null,
        InitialDate: this.taskForm.dateInit,
        LimitDate: this.taskForm.DateEnd,
        ObjetiveID: this.ObjectiveRow.ObjectiveId,
        CreatedBy: this.currentUser.EmployeeId,
        Details: this.taskForm.longDesc,
        qty: 0,
        type: "day",
        TypeStrategic: this.taskForm.typeStrategic,
        IsFixed: this.taskForm.fixed,
        EstimatedTime: this.taskForm.Time,
        MinuteHour: this.taskForm.minuteHour,
        NegotiationId: this.NegotiationId,
        ProspectId: this.ProspectId,
        CustomerCode: this.CustomerCode
      };

      if (this.WhatsThisFormFor === 1) {
        parameters.CombinedId = this.TaskRow.CombinedTaskId;
        parameters.CreatedBy = this.taskForm.creator;
      }

      await this.$http
        .post("/api/CMI/Task/AddTaskGantt", parameters)
        .then(() => {
          this.$message.success("Tarea creada Satisfactoriamente");
          this.FormCleaning();
          this.$emit("TaskSaved");
          this.$emit("ObjectiveSaved");
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    async ObjectiveCall() {
      let parameters = {
        Name: this.taskForm.shortDesc,
        CompanySeleted: "TB",
        DateInit: this.taskForm.dateInit,
        DateEnd: this.taskForm.DateEnd,
        TypeObjetive: "",
        Description: this.taskForm.longDesc,
        Details: this.taskForm.longDesc,
        PerpectiveId: this.taskForm.perspective,
        ResposibleID: this.taskForm.responsible,
        Priority: 0,
        Owner: this.currentUser.EmployeeId,
        TypeStrategic: this.taskForm.typeStrategic
      };

      if (this.WhatsThisFormFor === 3) {
        parameters.CombinedId = this.ObjectiveRow.ObjectiveCombinedId;
        parameters.Owner = this.taskForm.creator;
      }

      await this.$http
        .post("/api/CMI/Objetives/addNewObjetiveGantt", parameters)
        .then(() => {
          this.$message.success("Objetivo creado Satisfactoriamente");
          this.FormCleaning();
          this.$emit("ObjectiveSaved");
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    FormCleaning() {
      this.taskForm = {
        responsible: "",
        creator: "",
        perspective: "",
        typeStrategic: "",
        percentage: "",
        dateInit: "",
        DateEnd: "",
        shortDesc: "",
        longDesc: ""
      };
      (this.ShowDateAlert = false),
        (this.dateAlertTitle = ""),
        (this.dateIniAlertTitle = ""),
        (this.ShowDateIniAlert = false),
        (this.dateFinAlertTitle = ""),
        (this.ShowDateFinAlert = false),
        (this.DisableSaveButonCount = 0),
        (this.DisableSaveButonCount2 = 0),
        (this.DisableSaveButonCount3 = 0);
      this.disablePerspective = false;

      this.$refs.taskForm.resetFields();
    },
    onFixedChange(val) {
      this.taskForm.fixed = val;
      this.taskForm.chequed = val;
    },
    onFechaIniChange(fechaIni) {
      const dateEnd = new Date(this.taskForm.DateEnd);
      if (this.WhatsThisFormFor === 0 || this.WhatsThisFormFor === 1) {
        const iniDate = new Date(this.ObjectiveRow.DateInit);

        if (iniDate > fechaIni) {
          this.dateIniAlertTitle =
            "Error la fecha de inicio de la tarea no puede ser menor a la fecha de inicio del objetivo. " +
            "Fecha Inicio de objetivo: " +
            formatDate(iniDate);
          this.ShowDateIniAlert = true;
          this.DisableSaveButonCount = 1;
        } else {
          this.ShowDateIniAlert = false;
          this.DisableSaveButonCount = 0;
        }
        if (fechaIni > dateEnd) {
          this.ShowDateAlert = true;
          this.dateAlertTitle =
            "La fecha de inicio no puede ser mayor a la fecha fin";
          this.DisableSaveButonCount3 = 1;
        } else {
          this.ShowDateAlert = false;
          this.DisableSaveButonCount3 = 0;
        }
      } else {
        if (fechaIni > dateEnd) {
          this.ShowDateAlert = true;
          this.dateAlertTitle =
            "La fecha de inicio no puede ser mayor a la fecha fin";
          this.DisableSaveButonCount3 = 1;
        } else {
          this.ShowDateAlert = false;
          this.DisableSaveButonCount3 = 0;
        }
      }
    },
    onFechaFinChange(fechaFin) {
      const dateIni = new Date(this.taskForm.dateInit);
      if (this.WhatsThisFormFor === 0 || this.WhatsThisFormFor === 1) {
        // const finDate = new Date(this.ObjectiveRow.DateEnd);

        // if (finDate < fechaFin) {
        //   this.dateFinAlertTitle =
        //     "Error la fecha de fin de la tarea no puede ser mayor a la fecha de fin del objetivo. " +
        //     "Fecha Fin de objetivo: " +
        //     formatDate(finDate);
        //   this.ShowDateFinAlert = true;
        //   this.DisableSaveButonCount2 = 1;
        // } else {
        this.ShowDateFinAlert = false;
        this.DisableSaveButonCount2 = 0;
        // }
        if (fechaFin < dateIni) {
          this.ShowDateAlert = true;
          this.dateAlertTitle =
            "La fecha fin no puede ser menor a la fecha de inicio";
          this.DisableSaveButonCount3 = 1;
        } else {
          this.ShowDateAlert = false;
          this.DisableSaveButonCount3 = 0;
        }
      } else {
        if (fechaFin < dateIni) {
          this.ShowDateAlert = true;
          this.dateAlertTitle =
            "La fecha fin no puede ser menor a la fecha de inicio";
          this.DisableSaveButonCount3 = 1;
        } else {
          this.ShowDateAlert = false;
          this.DisableSaveButonCount3 = 0;
        }
      }
    },
    MinuteHoureChanged(minuteHours) {
      this.taskForm.minuteHour = minuteHours;
      // if (minuteHours === "h" && this.taskForm.Time > 8) {
      //   this.taskForm.Time = 8;
      // }
    },
    onTimeSelected(time) {
      this.taskForm.Time = time;
    }
  },
  watch: {
    TaskFormVisible(val) {
      this.dialogFormVisible = val;
    },
    TaskRow(TaskRow) {
      if (this.WhatsThisFormFor === 1) {
        this.taskForm.responsible = TaskRow.ResponsableId;
        this.taskForm.creator = TaskRow.CreatedBy;
        // this.taskForm.perspective = TaskRow.PerpectiveID;
        this.taskForm.typeStrategic = TaskRow.TypeStrategic;
        this.taskForm.percentage = TaskRow.PercentageProsposal;
        this.taskForm.dateInit = TaskRow.InitialDate;
        this.taskForm.DateEnd = TaskRow.LimiteDate;
        this.taskForm.shortDesc = TaskRow.ShortDescription;
        this.taskForm.longDesc = TaskRow.LongDescription;
        this.taskForm.chequed = TaskRow.IsFixed;
        this.taskForm.fixed = TaskRow.IsFixed;
        this.taskForm.Time = TaskRow.EstimatedTime;
        this.taskForm.minuteHour = TaskRow.MinuteHour;
      }
    },
    ObjectiveRow(ObjectiveRow) {
      if (this.WhatsThisFormFor === 3) {
        this.taskForm.responsible = ObjectiveRow.ResponsableId;
        this.taskForm.creator = ObjectiveRow.CreatedBy;
        this.taskForm.perspective = ObjectiveRow.PerpectiveID;
        this.taskForm.typeStrategic = ObjectiveRow.TypeStrategic;
        this.taskForm.percentage = ObjectiveRow.ExecutionPercentage;
        this.taskForm.dateInit = ObjectiveRow.DateInit;
        this.taskForm.DateEnd = ObjectiveRow.DateEnd;
        this.taskForm.shortDesc = ObjectiveRow.ObjectiveShortDescription;
        this.taskForm.longDesc = ObjectiveRow.ObjectiveLongDescription;
      } else if (this.WhatsThisFormFor === 0 || this.WhatsThisFormFor === 1) {
        this.taskForm.perspective = ObjectiveRow.PerpectiveID;
        this.disablePerspective = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .DatePicker .el-input--mini .el-input__inner {
  height: 28px;
  line-height: 28px;
  width: 30%;
}

.formItemTopPad {
  padding-top: 0rem;
}
</style>
